import { LogLevel } from '@signage-player/contracts';
import { AbstractLogger, isSameOrHigherLevel } from './AbstractLogger';
import * as Sentry from '@sentry/browser';
/**
 * Console logger implementation for main process
 */
export class SentryLogger extends AbstractLogger {
    constructor(minimumLevel, config) {
        super(minimumLevel);
        this.config = config;
        if (config.logging.sentry?.dsn) {
            Sentry.init({
                dsn: config.logging.sentry?.dsn,
            });
        }
    }
    setAdditionalContext(context) {
        super.setAdditionalContext(context);
        const additionalContext = this.getAdditionalContext();
        if (additionalContext.user) {
            Sentry.setUser({
                id: additionalContext.user.id,
                ip_address: additionalContext.user.ip_address,
            });
        }
        if (additionalContext.device?.device_unique_identifier) {
            Sentry.setTag('device.hash', additionalContext.device.device_unique_identifier);
        }
    }
    log(level, message, context) {
        if (isSameOrHigherLevel(level, this.minimumLevel) && this.config.logging.sentry?.dsn) {
            let severityLevel = 'log';
            switch (level) {
                case LogLevel.EMERGENCY:
                    severityLevel = 'fatal';
                    break;
                case LogLevel.ALERT:
                    severityLevel = 'fatal';
                    break;
                case LogLevel.CRITICAL:
                    severityLevel = 'fatal';
                    break;
                case LogLevel.ERROR:
                    severityLevel = 'error';
                    break;
                case LogLevel.WARNING:
                    severityLevel = 'warning';
                    break;
                case LogLevel.NOTICE:
                    severityLevel = 'info';
                    break;
                case LogLevel.INFO:
                    severityLevel = 'info';
                    break;
                case LogLevel.DEBUG:
                    severityLevel = 'debug';
                    break;
            }
            const additionalContext = this.getAdditionalContext();
            Sentry.captureMessage(`${message}`, {
                level: severityLevel,
                user: additionalContext.user
                    ? {
                        id: additionalContext.user.id,
                        ip_address: additionalContext.user.ip_address,
                    }
                    : undefined,
                contexts: {
                    ...additionalContext,
                    extras: { ...this.clearContext(context) },
                    app: {
                        app_identifier: this.config.appIdentifier,
                        app_name: this.config.appName,
                        app_version: this.config.version,
                        app_start_time: this.config.startTime.toISOString(),
                    },
                },
                tags: {
                    environment: this.config.environment,
                    ...(additionalContext.os?.name ? { 'os.name': additionalContext.os.name } : {}),
                    ...(additionalContext.os?.version ? { 'os.version': additionalContext.os.version } : {}),
                },
            });
        }
    }
    async destroy(timeout) {
        await Sentry.close(timeout);
    }
    async flush(timeout) {
        await Sentry.flush(timeout);
    }
    /**
     * Set minimum log level
     */
    setMinimumLevel(level) {
        this.minimumLevel = level;
    }
    /**
     * Get current minimum log level
     */
    getMinimumLevel() {
        return this.minimumLevel;
    }
}
export default SentryLogger;
//# sourceMappingURL=SentryLogger.js.map